<!-- Footer Section-->
<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 chatbotFooterMessage">
        ©2025-26 Fleetready. All rights reserved.
      </div>
    </div>
  </div>
</footer>
<!-- Footer Section-->
<!-- Chatbot popup -->
<ng-template #chatbotContainer let-modal>
  <div role="document" class="modal-dialog newclass mt-rt modal-sx">
    <div class="modal-content newclass">
      <!-- Chatbot header -->
      <div class="modal-header chatnotPopupHeader">
        <span class="fle">
          <img src="../../../assets/images/header-logo.png" class="icon-char">
        </span>
        <span class="fri">
          <h5 class="name">CerebrumX Support</h5>
        </span>
        <button type="button" class="btn-close crossbtn" data-dismiss="modal" (click)="removeSession();modal.dismiss('Cross click')"
          aria-hidden="true">
          <i class="fa fa-times timeFrame"></i>
        </button>
      </div>
      <!-- Chatbot header end -->

      <div style="background-image: url('../../../assets/images/header.png');"></div>
      <!--Chatbot body for bydefault Image -->
      <div class="modal-body bodyData" #scrollMe [scrollTop]="scrollMe.scrollHeight">
        <!-- Chatbot input and user input with download file-->
        <div class="message">
          <div *ngFor="let message of messages"
            [ngClass]="{'user-message-container': message.isUser, 'bot-message-container': !message.isUser}">
            <img *ngIf="!message.isUser" src="../../../assets/images/bot-image.png" class="bot-image" />
            <p class="message-text" *ngIf="message && !message.isUser" [innerHTML]="formatMessage(message.text)">{{ message.text }}</p>
            <p class="message-text-user" *ngIf="message.isUser">{{ message.text }}</p>
            <button *ngIf="message.pdfFile" class="download-btn" (click)="downloadPdf(message.pdfFile)">
              <i class='bx bx-download'></i>
              </button>

            <!-- Chatbot input and user input with download file end -->
            <img *ngIf="message.isUser" src="../../../assets/images/user-image.png" class="user-image" />
          </div>
        </div>
        <!--Typing indicator-->
        <div *ngIf="isTyping" class="typing-indicator flri">
          <span class="typing-dot" id="dot1"></span>
          <span class="typing-dot" id="dot2"></span>
          <span class="typing-dot" id="dot3"></span>
        </div>
        <!--Typing indicator end-->
      </div>
      <!--Chatbot body for bydefault Image -->
      <!-- Input and file uploading and send box-->
      <div class="modal-footer footerBg">
        <div class="input-container">
          <input type="text" [(ngModel)]="userMessage" [ngModelOptions]="{standalone: true}" (focus)="toggleTyping()"
            (blur)="toggleTyping()" (keyup.enter)="sendMessage()" placeholder="Type your message..." />
            <label class="upload-btn">
            <input type="file" (change)="uploadCSV($event)" (click)="$event.target.value=null" accept=".csv" hidden />
            <i class="fa fa-paperclip attachBtn"></i>
          </label>
        </div>

        <button type="submit" class="btn-primary data-demo-history" (click)="sendMessage();"><i
            class="fa fa-paper-plane sentBtn"></i></button>
      </div>
      <!-- Input and file uploading and send box end -->
    </div>
  </div>

</ng-template>
<!-- Chatbot popup end -->